"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var truncate_1 = require("../_commons/truncate");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var interfaces_1 = require("../../interfaces");
var CoreColumnChart_1 = require("./CoreColumnChart");
var withChart_1 = require("../_base/withChart");
var sanitizeStacking_1 = require("../_commons/sanitizeStacking");
//
// Internals
//
var columnChartDefinition = {
    chartName: "ColumnChart",
    bucketPropsKeys: ["measures", "viewBy", "stackBy", "filters", "sortBy"],
    bucketsFactory: function (props) {
        var measures = sdk_model_1.applyRatioRule(props.measures);
        var viewBy = truncate_1.truncate(props.viewBy, interfaces_1.ViewByAttributesLimit); // could be one or two attributes
        return [
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.MEASURES], measures)),
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.VIEW], viewBy)),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.STACK, props.stackBy),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("ColumnChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(dimensions_1.stackedChartDimensions)
            .withExecConfig(execConfig);
    },
    propOverridesFactory: function (props, buckets) {
        return {
            config: sanitizeStacking_1.sanitizeConfig(buckets, props.config),
        };
    },
};
var WrappedColumnChart = withChart_1.withChart(columnChartDefinition)(CoreColumnChart_1.CoreColumnChart);
/**
 * [ColumnChart](http://sdk.gooddata.com/gooddata-ui/docs/column_chart_component.html)
 *
 * Column chart shows data in vertical columns. Column charts can display one or multiple measures side by side,
 * divided by either attribute values or by a single measure stacked by attribute values.
 *
 * @public
 */
exports.ColumnChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measures, props.viewBy, props.stackBy, props.filters, props.sortBy], props.placeholdersResolutionContext), measures = _a[0], viewBy = _a[1], stackBy = _a[2], filters = _a[3], sortBy = _a[4];
    return (react_1.default.createElement(WrappedColumnChart, tslib_1.__assign({}, props, {
        measures: measures,
        viewBy: viewBy,
        stackBy: stackBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=ColumnChart.js.map